var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewcatalogfiltericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 3.5H8.5M8.5 3.5C8.5 4.60457 9.3954 5.5 10.5 5.5C11.6046 5.5 12.5 4.60457 12.5 3.5M8.5 3.5C8.5 2.39543 9.3954 1.5 10.5 1.5C11.6046 1.5 12.5 2.39543 12.5 3.5M12.5 3.5H18.5M2.5 10.5H14.5M14.5 10.5C14.5 11.6046 15.3954 12.5 16.5 12.5C17.6046 12.5 18.5 11.6046 18.5 10.5C18.5 9.3954 17.6046 8.5 16.5 8.5C15.3954 8.5 14.5 9.3954 14.5 10.5ZM6.5 17.5H18.5M6.5 17.5C6.5 16.3954 5.60457 15.5 4.5 15.5C3.39543 15.5 2.5 16.3954 2.5 17.5C2.5 18.6046 3.39543 19.5 4.5 19.5C5.60457 19.5 6.5 18.6046 6.5 17.5Z",
    stroke: "#A4A4A4",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewcatalogfiltericon);
export default __webpack_public_path__ + "static/media/newcatalogfiltericon.b37f1b11af0fb67406f07155b26c015e.svg";
export { ForwardRef as ReactComponent };